/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AecReferenceSourceOptionFragment = {
	id: string;
	description: { group: Types.AudioChannelGroup };
	features: { name: { name: string } | null };
};

export type AecChannelFragment = {
	id: string;
	features: {
		name: { name: string } | null;
		acousticEchoCancellation: {
			enabled: boolean;
			nonLinearProcessingLevel: Types.NonLinearProcessingLevel | null;
		} | null;
		acousticEchoCancellationMonoReference: {
			reference: { id: string };
			selectedReferenceSource: { id: string };
			referenceSourceOptions: Array<AecReferenceSourceOptionFragment> | null;
		} | null;
		acousticEchoCancellationStereoReference: {
			reference: { id: string };
			referenceSourceOptions: Array<AecReferenceSourceOptionFragment>;
			selectedLeftReferenceSource: { id: string };
			selectedRightReferenceSource: { id: string };
		} | null;
		acousticEchoCancellationErleMeterSource: {
			audioChannels: Array<{
				id: string;
				description: {
					index: number;
					constraints: {
						acousticEchoCancellationErle: {
							level: { range: { max: number; min: number; step: number } };
						} | null;
					};
				};
				features: {
					lobeConfiguration: { enabled: boolean } | null;
					automixerInputSendToMonoMix: { enabled: boolean } | null;
				};
			}>;
		} | null;
		channelConfiguration: { enabled: boolean } | null;
	};
	description: {
		constraints: {
			acousticEchoCancellation: {
				nonLinearProcessingLevel: { options: Array<Types.NonLinearProcessingLevel> | null } | null;
			} | null;
			acousticEchoCancellationPeak: { level: { range: { max: number; min: number; step: number } } } | null;
			acousticEchoCancellationErle: { level: { range: { max: number; min: number; step: number } } } | null;
			acousticEchoCancellationMonoReference: { referenceSourceOptions: { supported: boolean } } | null;
		};
		features: {
			acousticEchoCancellationErleMeterSource: { supported: boolean };
			channelConfiguration: { supported: boolean };
		};
	};
};

export type AecChannelUpdateFragment = {
	id: string;
	features:
		| {
				acousticEchoCancellation: {
					enabled: boolean;
					nonLinearProcessingLevel: Types.NonLinearProcessingLevel | null;
				} | null;
		  }
		| {
				acousticEchoCancellationMonoReference: {
					reference: { id: string };
					selectedReferenceSource: { id: string };
					referenceSourceOptions: Array<AecReferenceSourceOptionFragment> | null;
				} | null;
		  }
		| {
				acousticEchoCancellationStereoReference: {
					reference: { id: string };
					referenceSourceOptions: Array<AecReferenceSourceOptionFragment>;
					selectedLeftReferenceSource: { id: string };
					selectedRightReferenceSource: { id: string };
				} | null;
		  }
		| { automixerInputSendToMonoMix: { enabled: boolean } | null }
		| { channelConfiguration: { enabled: boolean } | null }
		| { lobeConfiguration: { enabled: boolean } | null }
		| { name: { name: string } | null }
		| {};
};

export type AecChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type AecChannelQueryOpResult = { node: AecChannelFragment | {} };

export type AecChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type AecChannelSubscriptionOpResult = { nodeChanges: AecChannelFragment | AecChannelUpdateFragment | {} };

export type AecChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type AecChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export type AecMonoReferenceMutationVariables = Types.Exact<{
	input: Types.AudioChannelAcousticEchoCancellationMonoReferenceInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type AecMonoReferenceMutationOpResult = {
	updateAcousticEchoCancellationMonoReferenceSource: { error: { code: Types.ErrorCode; message: string } | null };
};

export type AecStereoReferenceMutationVariables = Types.Exact<{
	input: Types.AudioChannelAcousticEchoCancellationStereoReferenceInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type AecStereoReferenceMutationOpResult = {
	updateAcousticEchoCancellationStereoReferenceSource: { error: { code: Types.ErrorCode; message: string } | null };
};

export const AecReferenceSourceOptionFragment = gql`
	fragment AecReferenceSourceOptionFragment on AudioChannel {
		id
		description {
			group
		}
		features {
			name {
				name
			}
		}
	}
`;
export const AecChannelFragment = gql`
	fragment AecChannelFragment on AudioChannel {
		id
		features {
			name {
				name
			}
			acousticEchoCancellation {
				enabled
				nonLinearProcessingLevel
			}
			acousticEchoCancellationMonoReference {
				reference {
					id
				}
				selectedReferenceSource {
					id
				}
				referenceSourceOptions {
					...AecReferenceSourceOptionFragment
				}
			}
			acousticEchoCancellationStereoReference {
				reference {
					id
				}
				referenceSourceOptions {
					...AecReferenceSourceOptionFragment
				}
				selectedLeftReferenceSource {
					id
				}
				selectedRightReferenceSource {
					id
				}
			}
			acousticEchoCancellationErleMeterSource {
				audioChannels {
					id
					description {
						constraints {
							acousticEchoCancellationErle {
								level {
									range {
										max
										min
										step
									}
								}
							}
						}
						index
					}
					features {
						lobeConfiguration {
							enabled
						}
						automixerInputSendToMonoMix {
							enabled
						}
					}
				}
			}
			channelConfiguration {
				enabled
			}
		}
		description {
			constraints {
				acousticEchoCancellation {
					nonLinearProcessingLevel {
						options
					}
				}
				acousticEchoCancellationPeak {
					level {
						range {
							max
							min
							step
						}
					}
				}
				acousticEchoCancellationErle {
					level {
						range {
							max
							min
							step
						}
					}
				}
				acousticEchoCancellationMonoReference {
					referenceSourceOptions {
						supported
					}
				}
			}
			features {
				acousticEchoCancellationErleMeterSource {
					supported
				}
				channelConfiguration {
					supported
				}
			}
		}
	}
	${AecReferenceSourceOptionFragment}
`;
export const AecChannelUpdateFragment = gql`
	fragment AecChannelUpdateFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelAcousticEchoCancellationChange {
				acousticEchoCancellation {
					enabled
					nonLinearProcessingLevel
				}
			}
			... on AudioChannelAcousticEchoCancellationMonoReferenceChange {
				acousticEchoCancellationMonoReference {
					reference {
						id
					}
					selectedReferenceSource {
						id
					}
					referenceSourceOptions {
						...AecReferenceSourceOptionFragment
					}
				}
			}
			... on AudioChannelAcousticEchoCancellationStereoReferenceChange {
				acousticEchoCancellationStereoReference {
					reference {
						id
					}
					referenceSourceOptions {
						...AecReferenceSourceOptionFragment
					}
					selectedLeftReferenceSource {
						id
					}
					selectedRightReferenceSource {
						id
					}
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
			... on AudioChannelAutomixerInputSendToMonoMixChange {
				automixerInputSendToMonoMix {
					enabled
				}
			}
			... on AudioChannelLobeConfigurationChange {
				lobeConfiguration {
					enabled
				}
			}
		}
	}
	${AecReferenceSourceOptionFragment}
`;
export const AecChannelQueryDocument = gql`
	query AecChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...AecChannelFragment
		}
	}
	${AecChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AecChannelQueryGQL extends Apollo.Query<AecChannelQueryOpResult, AecChannelQueryVariables> {
	override document = AecChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AecChannelSubscriptionDocument = gql`
	subscription AecChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on AudioChannel {
				...AecChannelFragment
			}
			... on AudioChannelChange {
				...AecChannelUpdateFragment
			}
		}
	}
	${AecChannelFragment}
	${AecChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class AecChannelSubscriptionGQL extends Apollo.Subscription<
	AecChannelSubscriptionOpResult,
	AecChannelSubscriptionVariables
> {
	override document = AecChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AecChannelMutationDocument = gql`
	mutation AecChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class AecChannelMutationGQL extends Apollo.Mutation<AecChannelMutationOpResult, AecChannelMutationVariables> {
	override document = AecChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AecMonoReferenceMutationDocument = gql`
	mutation AecMonoReferenceMutation(
		$input: AudioChannelAcousticEchoCancellationMonoReferenceInput!
		$injectKeyring: String
	) {
		updateAcousticEchoCancellationMonoReferenceSource(input: $input, keyring: $injectKeyring) {
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class AecMonoReferenceMutationGQL extends Apollo.Mutation<
	AecMonoReferenceMutationOpResult,
	AecMonoReferenceMutationVariables
> {
	override document = AecMonoReferenceMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const AecStereoReferenceMutationDocument = gql`
	mutation AecStereoReferenceMutation(
		$input: AudioChannelAcousticEchoCancellationStereoReferenceInput!
		$injectKeyring: String
	) {
		updateAcousticEchoCancellationStereoReferenceSource(input: $input, keyring: $injectKeyring) {
			error {
				code
				message
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class AecStereoReferenceMutationGQL extends Apollo.Mutation<
	AecStereoReferenceMutationOpResult,
	AecStereoReferenceMutationVariables
> {
	override document = AecStereoReferenceMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
